export * from './HeroCanvasPage';
